import rta from "../images/Portfolio/rta.jpg";
import erp from "../images/Portfolio/ERP.png";
import ecom from "../images/Portfolio/Ecomm.png";
import gym from "../images/Portfolio/Gymapp.png";
import sbm from "../images/Portfolio/SBM.png";

function Projects() {
  const projects = [
    {
      id: 1,
      title: "Smartvision – Dubai RTA CMS & Kiosk Systems",
      desc: (
        <p>
          I contributed to the development of a centralized management system
          for Dubai RTA’s kiosk network, enabling real-time monitoring of
          machine health, heartbeat status, and operational activities. I also
          built a QR-based refund system, automated email and notification
          workflows, and multiple reporting modules using AngularJS and
          Chart.js. Additionally, I collaborated with the UI/UX team to design
          and test wireframes and application directly on kiosk screens,
          ensuring a seamless and user-friendly interface.
          <br />
          <b>
            NOTE: Image taken during internal testing of the RTA smart kiosk
            screens. Shown only for demonstration of my contribution — all
            rights belong to Dubai RTA.
          </b>
        </p>
      ),
      source: rta,
    },

    {
      id: 2,
      title: "Mini ERP System – ASP.NET Core & SQL Server",
      desc: (
        <p>
          I built a simplified ERP system using ASP.NET Core MVC and SQL Server,
          focusing on core enterprise features and clean UI/UX. The system
          includes role-based authentication, an admin dashboard, employee
          management, department tracking, ticketing, request management, and a
          weekly attendance log. I structured the application using MVC
          principles, implemented CRUD operations with Entity Framework Core,
          and designed a responsive dashboard that displays real-time
          statistics, tables, and user details.This project demonstrates my
          ability to design full-stack business applications, work with
          relational databases, and build functional, scalable internal tools.
        </p>
      ),
      source: erp,
    },
    {
      id: 3,
      title: "SuperMarket Web App – ASP.NET Core MVC",
      desc: (
        <p>
          I built a basic supermarket-style e-commerce web application using
          ASP.NET Core MVC with product listings, category filters, a shopping
          cart, and user login/logout functionality. The system displays
          products with images, prices, and categories, allowing users to browse
          items and add them to their cart. The UI is clean and responsive, and
          the backend is connected to a SQL Server database for managing
          products and user data. This project helped me understand core
          e-commerce workflows, MVC architecture, CRUD operations, and
          session-based cart functionality.
        </p>
      ),
      source: ecom,
    },
    {
      id: 4,
      title:
        "Gym Management System (WinForms, .NET Framework, ADO.NET, SQL Server)",
      desc: (
        <p>
          This desktop-based Gym Management System was built using .NET
          Framework WinForms, ADO.NET, and SQL Server for data storage. It
          provides a complete solution for managing gym members, staff,
          equipment, and subscription details. The system includes features such
          as real-time member tracking, membership renewal management, fee
          tracking, and detailed reporting. It also includes a centralized
          dashboard where admins can view member profiles, monitor activity,
          update records, and maintain the overall health of the gym database.
        </p>
      ),
      source: gym,
    },

    {
      id: 5,
      title:
        "SBM System – Sales & Business Management (ASP.NET Core, Entity Framework, SQL Server)",
      desc: (
        <p>
          SBM System is a web-based business management application developed
          using ASP.NET Core MVC, Entity Framework Core, and SQL Server. The
          platform helps small and medium businesses manage their sales, leads,
          purchases, and accounting operations from a unified dashboard. It
          includes visual analytics such as charts and summary cards for
          expenses, profits, and sales performance. The system automates
          calculations like total profits, losses, and monthly reports, offering
          a smooth and modern UI for admins to efficiently track business
          metrics and maintain financial records.
        </p>
      ),
      source: sbm,
    },
  ];

  return (
    <div>
      <section class="py-5">
        <div class="container px-5 mb-5">
          <div class="text-center mb-5">
            <h1 class="display-5 fw-bolder mb-0">
              <span class="text-gradient d-inline">Projects</span>
            </h1>
          </div>
          <div class="row gx-5 justify-content-center">
            <div class="col-lg-11 col-xl-9 col-xxl-8">
              {projects.map((project) => (
                <div
                  key={project.id}
                  className="card overflow-hidden shadow rounded-4 border-0 mb-4"
                >
                  <div className="card-body p-0">
                    <div className="project-card p-4">
                      <div className="">
                        <h2 className="fw-bolder">{project.title}</h2>
                        <p>{project.desc}</p>
                      </div>
                      <img
                        className="project-image"
                        src={project.source}
                        alt={project.title}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Projects;
